import { Create, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar } from 'react-admin'
import { trimNameFields, validateNameField } from '../validators/NameValidators'
import PhoneNumberInput from '../fields/PhoneNumberInput'

const ProviderCreateToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" />
  </Toolbar>
)

const makeProviderName = (entry) => {
  return (
    entry.lastName +
    /* (entry.suffixName ? ' ' + entry.suffixName : '') + */
    ', ' +
    entry.firstName +
    (entry.middleName ? ' ' + entry.middleName : '')
  )
}

const transform = (data) => {
  const trimmed = trimNameFields(data)
  return {
    ...trimmed,
    displayName: makeProviderName(trimmed) + ' (' + trimmed.clinicName + ')',
  }
}

export const ProviderCreate = () => (
  <Create mutationMode="pessimistic" transform={transform}>
    <SimpleForm className="form-layout" toolbar={<ProviderCreateToolbar />}>
      <SelectInput
        required
        label="Status"
        source="status"
        choices={[
          {
            id: 'pending',
            name: 'Pending',
          },
          {
            id: 'active',
            name: 'Active',
          },
          {
            id: 'inactive',
            name: 'Inactive',
          },
        ]}
      />
      <TextInput required label="Last Name" source="lastName" validate={validateNameField} />
      <TextInput required label="First Name" source="firstName" validate={validateNameField} />
      <TextInput label="Middle Name/Initial" source="middleName" validate={validateNameField} />
      <TextInput label="Name Suffix" source="suffixName" validate={validateNameField} />
      <TextInput required label="Clinic" source="clinicName" validate={validateNameField} />
      <TextInput label="Address 1" source="address1" />
      <TextInput label="Address 2" source="address2" />
      <TextInput label="City" source="city" />
      <TextInput label="State" source="state" />
      <TextInput label="Zip" source="zip" />
      <TextInput label="Email" source="email" />
      <PhoneNumberInput label="Phone" source="phone" />
      <TextInput label="Fax" source="fax" />
      <TextInput label="Website" source="website" />
      <TextInput label="Admin/Asst Name" source="adminContact" />
      <TextInput label="Admin/Asst Email" source="adminEmail" />
      <PhoneNumberInput label="Admin/Asst Phone" source="adminPhone" />
      <SelectInput
        required
        choices={[
          {
            id: 'Yes',
            name: 'Yes',
          },
          {
            id: 'No',
            name: 'No',
          },
        ]}
        label="Fax Positive Results?"
        source="faxPositiveResults"
      />
      <SelectInput
        required
        choices={[
          {
            id: 'Yes',
            name: 'Yes',
          },
          {
            id: 'No',
            name: 'No',
          },
        ]}
        label="Fax Negative Results?"
        source="faxNegativeResults"
      />
      <TextInput label="Notes" multiline={true} source="notes" />
    </SimpleForm>
  </Create>
)
